import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface RedirectProps {
  to: string;
  external?: boolean;
}

/**
 * Component that redirects to a URL
 * @param to - The URL to redirect to
 * @param external - If true, redirects to external URL. If false, uses React Router navigation
 */
export function Redirect({ to, external = false }: RedirectProps) {
  const navigate = useNavigate();

  useEffect(() => {
    if (external) {
      // Redirect to external URL
      window.location.href = to;
    } else {
      // Use React Router navigation for internal routes
      navigate(to, { replace: true });
    }
  }, [to, external, navigate]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <p>Redirecting...</p>
    </div>
  );
}
